import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin, Alert, Typography } from 'antd';
import { aiSearchService } from 'services/ai-search';
import { handleApiSuccess, handleApiError } from 'utils';
import 'assets/css/search.css';

const { Title, Paragraph, Text } = Typography;

const SearchResults = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState(null);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const searchQuery = urlParams.get('q');

    if (searchQuery) {
      setQuery(searchQuery);
      performSearch(searchQuery);
    }
  }, [location.search]);

  const performSearch = async (searchQuery) => {
    setLoading(true);
    setError(null);

    try {
      const response = await aiSearchService(searchQuery);
      handleApiSuccess(response);
      setSearchResults(response.data.data);
    } catch (err) {
      const errorMessage = handleApiError(err);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const renderSearchResults = () => {
    if (!searchResults) return null;

    const { aiResponse, totalResults, searchType, timestamp } = searchResults;

    return (
      <div>
        <div style={{ marginBottom: '24px' }}>
          <Title level={2}>Search Results for "{query}"</Title>
          <Text type="secondary">
            Found {totalResults} result{totalResults !== 1 ? 's' : ''} in{' '}
            {searchType}
          </Text>
          <br />
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Search performed at: {new Date(timestamp).toLocaleString()}
          </Text>
        </div>

        {aiResponse ? (
          <div className="ai-search-results">
            <div
              style={{
                backgroundColor: '#FFF',
                padding: '20px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
              }}
            >
              <div
                style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}
                dangerouslySetInnerHTML={{ __html: aiResponse }}
              />
            </div>
          </div>
        ) : (
          <Alert
            message="No results found"
            description="Try adjusting your search terms or check the spelling."
            type="info"
            showIcon
          />
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
        <div style={{ marginTop: '16px' }}>
          <Text>Searching knowledge base...</Text>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Search Error"
        description={error}
        type="error"
        showIcon
        style={{ margin: '20px 0' }}
      />
    );
  }

  return <div style={{ padding: '24px' }}>{renderSearchResults()}</div>;
};

export default SearchResults;
